import React, { Suspense, lazy } from 'react';
import EditDiagramModal from './EditDiagramModal';

const VideoExcalidrawModal = lazy(() => import('../video/VideoExcalidrawModal'));

/**
 * Renders the diagram editor modal (and its Excalidraw sketch companion) from a
 * useDiagramEditor() instance. Spread the hook return value as props:
 *   <DiagramEditorHost {...diagramEditor} />
 */
const DiagramEditorHost = ({
  diagramEditor,
  setDiagramEditor,
  diagramEditorError,
  isSavingDiagram,
  closeDiagramEditor,
  handleRegenerateSvg,
  handleSaveDiagram,
  svgPreviewDoc,
  tikzPreviewDoc,
}) => (
  <>
    <EditDiagramModal
      diagramEditor={diagramEditor}
      setDiagramEditor={setDiagramEditor}
      diagramEditorError={diagramEditorError}
      isSavingDiagram={isSavingDiagram}
      onClose={closeDiagramEditor}
      onRegenerateSvg={handleRegenerateSvg}
      onSaveDiagram={handleSaveDiagram}
      onOpenExcalidraw={() => setDiagramEditor((prev) => ({ ...prev, excalidrawOpen: true }))}
      svgPreviewDoc={svgPreviewDoc}
      tikzPreviewDoc={tikzPreviewDoc}
    />

    {diagramEditor.excalidrawOpen && (
      <Suspense fallback={null}>
        <VideoExcalidrawModal
          slide={{
            title: `Question ${diagramEditor.questionNumber || ''}`,
            excalidraw_elements: diagramEditor.excalidrawElements,
            excalidraw_files: diagramEditor.excalidrawFiles,
            diagram_svg: diagramEditor.svgCode,
          }}
          onSave={(svgString, elements, files) => {
            setDiagramEditor((prev) => ({
              ...prev,
              svgCode: svgString,
              excalidrawElements: elements,
              excalidrawFiles: files || null,
              excalidrawOpen: false,
              editorMode: 'svg',
            }));
          }}
          onClose={() => setDiagramEditor((prev) => ({ ...prev, excalidrawOpen: false }))}
        />
      </Suspense>
    )}
  </>
);

export default DiagramEditorHost;
